/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DraftOfferIdAuthenticationRefreshPost200ResponseDtoDto } from '../models/draft-offer-id-authentication-refresh-post-200-response-dto-dto';


/**
 * the SaaCommandAuthenticationRefresh API
 */
@Injectable({
  providedIn: 'root',
})
export class SaaCommandAuthenticationRefreshService extends BaseService {
  constructor(
    config: SalesApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation draftOfferIdAuthenticationRefreshPost
   */
  static readonly DraftOfferIdAuthenticationRefreshPostPath = '/draft/{offerId}/authentication/refresh';

  /**
   * Refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `draftOfferIdAuthenticationRefreshPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  draftOfferIdAuthenticationRefreshPost$Response(params: {
    offerId: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<DraftOfferIdAuthenticationRefreshPost200ResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, SaaCommandAuthenticationRefreshService.DraftOfferIdAuthenticationRefreshPostPath, 'post');
    if (params) {
      rb.path('offerId', params.offerId, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DraftOfferIdAuthenticationRefreshPost200ResponseDtoDto>;
      })
    );
  }

  /**
   * Refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `draftOfferIdAuthenticationRefreshPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  draftOfferIdAuthenticationRefreshPost(params: {
    offerId: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<DraftOfferIdAuthenticationRefreshPost200ResponseDtoDto> {

    return this.draftOfferIdAuthenticationRefreshPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<DraftOfferIdAuthenticationRefreshPost200ResponseDtoDto>) => r.body as DraftOfferIdAuthenticationRefreshPost200ResponseDtoDto)
    );
  }

}
